module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "qihuo-contract"
  }, [_c('p', {
    staticClass: "qihuo-contract-header"
  }, [_vm._v("商务合作")]), _vm._v(" "), _c('div', {
    staticClass: "qihuo-contract-body"
  }, [_c('div', [_c('img', {
    attrs: {
      "src": require("@/assets/img/commons/accessData.png")
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4d534e6f","hasScoped":true,"transformToRequire":{"img":["src","srcset"]}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contact.vue
// module id = uKUY
// module chunks = 2